import { forwardRef, type PropsWithChildren } from "react";
import { customColors } from "tailwind.config";

import ChevronIcon from "$/lib/icons/ChevronIcon";
import { cn } from "$/lib/utils/functions/misc.functions";

import type { CarouselArrowButtonProps } from "./CarouselArrowButton.types";

const CarouselArrowButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<CarouselArrowButtonProps>
>(({ buttonType, className, carouselType, ...props }, forwardedRef) => {
  return (
    <button
      ref={forwardedRef}
      className={cn(
        "decoration-none z-[1] m-0 flex h-6 w-6 cursor-pointer touch-manipulation appearance-none items-center justify-center rounded-full border-0 bg-transparent bg-white p-0 disabled:cursor-default disabled:opacity-60",
        { "bg-primary": carouselType === "view-4" },
        className,
      )}
      type="button"
      {...props}
    >
      <ChevronIcon
        width={14}
        height={14}
        className={cn({ "rotate-180": buttonType === "prev" })}
        color={carouselType === "view-4" ? "white" : customColors.tertiary[500]}
      />
    </button>
  );
});

CarouselArrowButton.displayName = "CarouselArrowButton";

export default CarouselArrowButton;
